import React from "react";
import { Layout, Menu } from "antd";
import {
  UserOutlined,
  SettingOutlined,
  DatabaseOutlined,
  ScheduleOutlined,
  UploadOutlined
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: "/",
      icon: <UploadOutlined />,
      label: "Upload",
    },
    {
      key: "/documents",
      icon: <DatabaseOutlined />,
      label: "Documents",
    },
    {
      key: "/reminders",
      icon: <ScheduleOutlined />,
      label: "Reminders",
    },
    {
      key: "/members",
      icon: <UserOutlined />,
      label: "Members",
    },
    {
      key: "/settings",
      icon: <SettingOutlined />,
      label: "Settings",
    },
  ];

  return (
    <Sider
      width={200}
      theme="dark"
      style={{
        position: "fixed",
        left: 0,
        top: 64,
        height: "100vh",
      }}
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
      />
    </Sider>
  );
};

export default Sidebar;
